import { Location as DataLocation } from '@weave/schema-gen-ts/dist/schemas/location/v2/data-location/messages.pb';
import { useQuery } from 'react-query';
import { getLocationData as getLocationDataAuthenticated } from '@frontend/api-location';
import { getPaymentsPlatformQueryKey } from '../../utils';

export type UseLocationDataProps = {
  locationId: string;
  isPublic: boolean;
};

export const getUseLocationDataQueryKey = (locationId: string, isPublic: boolean) =>
  getPaymentsPlatformQueryKey('location-data', locationId, isPublic);

const getLocationDataPublic = (_props: { locationId: string }) => Promise.resolve({} as DataLocation);

export const useLocationData = ({ locationId, isPublic }: UseLocationDataProps) => {
  return useQuery({
    queryKey: getUseLocationDataQueryKey(locationId, isPublic),
    queryFn: () => (isPublic ? getLocationDataPublic({ locationId }) : getLocationDataAuthenticated({ locationId })),
    enabled: !!locationId,
  });
};
